<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex pa-0 xs12 sm8 md6 lg4>
            <v-card class="elevation-10">
              <v-toolbar color="teal darken-4" class="white--text" height="50">
                <v-toolbar-title>{{ header }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text style="padding: 20px 30px 5px 30px;">
                <v-form class="loginForm">
                  <v-text-field v-if="!changePassword" prepend-icon="person" color="teal" ref="userName" type="text" v-model="userName" class="field" autocomplete="new-password" v-on:keyup.enter="doLogin"></v-text-field>
                  <v-text-field v-if="!changePassword" prepend-icon="lock" color="teal" id="password" type="password" v-model="password" class="field" autocomplete="new-password" v-on:keyup.enter="doLogin"></v-text-field>
                  <div v-if="changePassword">Enter a new password</div>
                  <v-text-field v-show="changePassword" prepend-icon="lock" color="teal" ref="newPasswordOne" name="newPassword1" id="newPassword1" type="password" v-model="newPassword1" class="field" autocomplete="new-password" v-on:keyup.enter="doChangePassword"></v-text-field>
                  <v-text-field v-show="changePassword" prepend-icon="lock" color="teal" name="newPassword2" id="newPassword2" type="password" v-model="newPassword2" class="field" autocomplete="new-password" v-on:keyup.enter="doChangePassword"></v-text-field>
                  <div v-if="loginError !== ''" class="error-message">
                    {{ loginError }}
                  </div>
                  <div v-if="loginError === ''" style="height: 20px;">
                  </div>
                </v-form>
              </v-card-text>
              <v-card-actions style="padding: 0 15px 15px 0;" class="buttons">
                <v-spacer></v-spacer>
                <v-btn v-if="!changePassword" color="teal darken-4" class="white--text" v-on:click="doLogin" :disabled="loginButtonDisabled">Login</v-btn>
                <v-btn v-if="changePassword" color="teal darken-4" class="white--text" v-on:click="doChangePassword" :disabled="changePasswordButtonDisabled">Change password</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <div style="position: absolute; top: calc(100vh - 100px); left: calc(50vw - 76px);">
          <img src="/static/logo.png" height="50"/>
        </div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Main from '@/assets/javascript/main'

export default {
  name: 'Login',
  data () {
    return {
      header: 'Tree Logistics System',
      userName: '',
      password: '',
      loginError: '',
      changePassword: false,
      newPassword1: '',
      newPassword2: ''
    }
  },
  mounted () {
    this.$refs.userName.focus()
  },
  computed: {
    loginButtonDisabled: function () {
      return this.userName === '' || this.password === '' || this.password.length < 8
    },
    changePasswordButtonDisabled: function () {
      return this.newPassword1.trim().length < 8 || this.newPassword1.trim().length < 8 || this.newPassword1 !== this.newPassword2
    }
  },
  methods: {
    doLogin () {
      this.loginError = ''
      this.$store.dispatch('session/login', { userName: this.userName, password: this.password })
        .then((response) => {
          let session = this.$store.state.session

          this.changePassword = session.temporaryPassword
          if (this.changePassword) {
            this.$nextTick(() => this.$refs.newPasswordOne.focus())
          } else {
            let main = new Main(this.$store, this.$router)
            main.checkSession()

            this.$store.dispatch('page/setSidebarItem', { key: 'dashboard' })
            this.$router.push({name: 'Main'})
          }
        })
        .catch((error) => {
          this.loginError = error.message
        })
    },
    doChangePassword () {
      // console.log('Change password in backend')
      this.$store.dispatch('user/changePassword', { password: this.newPassword1 })
        .then((response) => {
          // console.log(response)
          this.$router.push({name: 'Main'})
        })
        .catch((error) => {
          console.log('Login error: \'' + error.message + '\'')
          this.loginError = error.message
        })
    }
  }
}
</script>

<style scoped>
  .loginForm {
    padding: 0 30px;
  }
  .field {
    margin-top: 0;
    padding-top: 10px;
  }
  .error-message {
    text-align: center;
    font-weight: bold;
    padding: 15px 10px 5px 10px;
  }
  .v-input,
  .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 15px !important;
    margin-bottom: 0 !important;
  }
  .v-input {
    font-size: 13pt !important;
    margin-left: 20px;
    margin-right: 20px;
  }
  .v-btn {
    font-size: 15px !important;
    padding: 0 30px;
    height: 32px !important;
  }
  .v-toolbar__title {
    padding-left: 10px;
    font-size: 20px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue